import { FC } from 'react';
import {
  InputWrapper,
  StyledInput,
  InputWithoutPaddingWrapper,
} from 'containers/CourtManagerAssignedExpertise/style';
import { InputLabel } from '@material-ui/core';

interface TextElementProps {
  label: string;
  value: string;
  withoutPadding?: boolean;
}

const TextElement: FC<TextElementProps> = props => {
  const { label, value } = props;
  return props.withoutPadding ? (
    <InputWithoutPaddingWrapper>
      <InputLabel htmlFor="component-helper">{label}</InputLabel>
      <StyledInput fullWidth value={value || ''} disabled />
    </InputWithoutPaddingWrapper>
  ) : (
    <InputWrapper>
      <InputLabel htmlFor="component-helper">{label}</InputLabel>
      <StyledInput fullWidth value={value || ''} disabled />
    </InputWrapper>
  );
};

export default TextElement;
